// PartBPage8.jsx - Part B Page 8 (Post-project reflections) for HPC Report
import React from 'react';

const PartBPage8 = ({ data }) => {
  const teacherComments = data?.page_8?.teacher_comments || {};
  const reflection = data?.page_8?.learner_reflection || {};

  const reflectionPrompts = [
    { key: 'what_i_learned', label: 'What did I learn from this project?' },
    { key: 'most_enjoyable_part', label: 'What was the most enjoyable part of the project?' },
    { key: 'three_strengths', label: 'Three strengths I demonstrated in this project' },
    { key: 'challenges_faced', label: 'What were the challenges I faced doing the project?' },
    { key: 'two_areas_improvement', label: 'Two areas of improvement I identified in this project' },
    { key: 'questions_still_have', label: 'Some questions I still have...' },
    { key: 'teacher_modifications', label: 'How could your teacher modify this project to make it more interesting?' }
  ];

  return (
    <div style={{ width: '210mm', minHeight: '297mm', padding: '20mm', backgroundColor: 'white', boxSizing: 'border-box', fontFamily: 'Arial, sans-serif', position: 'relative' }}>
      <div style={{ position: 'absolute', top: 0, right: 0, width: 0, height: 0, borderStyle: 'solid', borderWidth: '0 80px 80px 0', borderColor: 'transparent #F4824C transparent transparent' }} />

      {/* Header */}
      <div style={{ backgroundColor: '#F4824C', color: 'white', fontSize: '14px', fontWeight: 'bold', padding: '10px', textAlign: 'center', marginBottom: '16px' }}>
        Post-project reflections
      </div>

      {/* Teacher Comments */}
      <div style={{ marginBottom: '16px' }}>
        <div style={{ fontSize: '11px', fontWeight: 'bold', marginBottom: '6px' }}>
          Final comments by the teacher (if any):
        </div>
        <div style={{ backgroundColor: '#FFE5D5', padding: '10px', minHeight: '50px', fontSize: '11px', borderRadius: '4px', marginBottom: '8px' }}>
          {teacherComments.most_important_contribution || 'The learner\'s most important contribution tothe project was...'}
        </div>
        <div style={{ backgroundColor: '#FFE5D5', padding: '10px', minHeight: '50px', fontSize: '11px', borderRadius: '4px' }}>
          {teacherComments.areas_for_improvement || 'To perform better in future projects, the learner should work on...'}
        </div>
      </div>

      {/* Learner Reflection */}
      <div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '10px' }}>
          <svg width="40" height="60" viewBox="0 0 40 60">
            <circle cx="20" cy="15" r="10" fill="#333" stroke="#000" strokeWidth="2" />
            <line x1="20" y1="25" x2="20" y2="45" stroke="#000" strokeWidth="3" />
            <line x1="20" y1="30" x2="12" y2="40" stroke="#000" strokeWidth="3" />
            <line x1="20" y1="30" x2="28" y2="40" stroke="#000" strokeWidth="3" />
            <line x1="20" y1="45" x2="12" y2="55" stroke="#000" strokeWidth="3" />
            <line x1="20" y1="45" x2="28" y2="55" stroke="#000" strokeWidth="3" />
          </svg>
          <div style={{ backgroundColor: 'white', border: '2px solid #333', borderRadius: '8px', padding: '6px 10px', fontSize: '9px', position: 'relative' }}>
            Think about how<br />you did in this<br />project.
            <div style={{ position: 'absolute', left: '-10px', top: '50%', transform: 'translateY(-50%)', width: 0, height: 0, borderStyle: 'solid', borderWidth: '5px 10px 5px 0', borderColor: 'transparent white transparent transparent' }} />
          </div>
        </div>

        <div style={{ backgroundColor: '#4A90A4', color: 'white', padding: '8px', fontWeight: 'bold', fontSize: '12px', textAlign: 'center', marginBottom: '10px' }}>
          Learner Reflection
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px' }}>
          {reflectionPrompts.slice(0, 6).map((prompt, idx) => (
            <div key={prompt.key} style={{ position: 'relative' }}>
              <div style={{ backgroundColor: '#B3D9E8', padding: '8px', minHeight: '100px', border: '1px solid #4A90A4', fontSize: '10px', fontWeight: idx < 2 ? 'bold' : 'normal', lineHeight: '1.4' }}>
                <div style={{ marginBottom: '4px', fontWeight: 'bold' }}>{prompt.label}</div>
                <div style={{ fontSize: '10px' }}>{reflection[prompt.key] || ''}</div>
              </div>
              {idx < 5 && (
                <div style={{ position: 'absolute', [idx % 2 === 0 ? 'right' : 'left']: '-15px', bottom: '-10px', fontSize: '24px', color: '#333' }}>
                  {idx % 2 === 0 ? '→' : '←'}
                </div>
              )}
            </div>
          ))}
          <div style={{ gridColumn: '1 / -1' }}>
            <div style={{ backgroundColor: '#B3D9E8', padding: '8px', minHeight: '80px', border: '1px solid #4A90A4', fontSize: '10px' }}>
              <div style={{ marginBottom: '4px', fontWeight: 'bold' }}>{reflectionPrompts[6].label}</div>
              <div>{reflection[reflectionPrompts[6].key] || ''}</div>
            </div>
          </div>
        </div>
      </div>

      {/* Page Number */}
      <div style={{ position: 'absolute', bottom: '15mm', left: '50%', transform: 'translateX(-50%)', fontSize: '10px', color: '#666', fontWeight: 'bold' }}>18</div>

      {/* Bottom Corners */}
      <div style={{ position: 'absolute', bottom: 0, left: 0, width: 0, height: 0, borderStyle: 'solid', borderWidth: '60px 0 0 60px', borderColor: 'transparent transparent transparent #F4824C' }} />
      <div style={{ position: 'absolute', bottom: 0, right: 0, width: 0, height: 0, borderStyle: 'solid', borderWidth: '60px 60px 0 0', borderColor: 'transparent #F4824C transparent transparent', opacity: 0.3 }} />
    </div>
  );
};

export default PartBPage8;
